import { render, staticRenderFns } from "./hzIndex.vue?vue&type=template&id=2b41cacc&scoped=true&"
import script from "./hzIndex.vue?vue&type=script&lang=js&"
export * from "./hzIndex.vue?vue&type=script&lang=js&"
import style0 from "./hzIndex.vue?vue&type=style&index=0&id=2b41cacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41cacc",
  null
  
)

export default component.exports